module.exports = __webpack_public_path__ + "img/ct_email@2x.e7da8bcc.png";